"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookies = getCookies;

/**
 * Grabs cookie attribute from document and converts to JSON
 * @return {Object}
 */
function getCookies() {
  if (typeof document === 'undefined') return {};
  if (!document.cookie) return {};
  return document.cookie.split('; ').reduce((memo, cookie) => {
    const [key, value] = cookie.split('=');
    memo[key] = value;
    return memo;
  }, {});
}